import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';
export default defineAppCommands({
  id: 'tasks.create',
  loadTitles: () => Promise.all([import('./messages'), import('../../messages-ready/inbox-unified')]),
  providers: [
    {
      id: 'tasks.create',
      items: (query) => {
        const title = t('inbox.new');
        return !query || `${title} task Aufgabe`.toLowerCase().includes(query.toLowerCase())
          ? [
              {
                id: 'tasks.new',
                title,
                group: t('inbox.title'),
                icon: 'task',
                href: '/inbox?create=true',
                create: true,
              },
            ]
          : [];
      },
    },
    {
      id: 'tasks.views',
      items: (query) => {
        const title = t('tp.tasks.title');
        return !query ||
          `${title} tasks aufgaben board calendar kalender`.toLowerCase().includes(query.toLowerCase())
          ? [
              {
                id: 'tasks.all',
                title,
                group: t('inbox.title'),
                icon: 'board',
                href: '/tasks',
              },
            ]
          : [];
      },
    },
  ],
});
